import styled from 'styled-components'

import type { Trend } from '../model'
import type { ClassNameProps } from '@root/shared/react'
import type { IconProps } from '@root/shared/ui-kit'

export interface TrendColorProps extends IconProps, ClassNameProps {
  trend: Trend.Trend
  variant?: 'bright' | 'candle'
}

export const TrendColor: React.FC<TrendColorProps> = ({
  trend,
  variant = 'bright',
  className,
  children,
}) => {
  return (
    <Root data-trend={trend} data-variant={variant} className={className}>
      {children}
    </Root>
  )
}

const Root = styled.div`
  &[data-variant='bright'] {
    &[data-trend='up'] {
      color: var(--upAccent-9);
    }
    &[data-trend='neutral'] {
      color: var(--text-11);
    }
    &[data-trend='down'] {
      color: var(--downAccent-9);
    }
  }

  &[data-variant='candle'] {
    &[data-trend='up'] {
      color: var(--up-9);
    }
    &[data-trend='neutral'] {
      color: var(--text-11);
    }
    &[data-trend='down'] {
      color: var(--down-9);
    }
  }
`
